interface Parser<T> {
  parse(value: string): T;
  stringify(value: T): string;
}

const defaultParser: Parser<string> = {
  parse: (v) => v,
  stringify: (v) => v,
};

export class SessionStorageKey<T = string, P extends Parser<T> = Parser<T>> {
  public readonly key: string;

  private readonly parser: P;

  public readonly namespace: string;

  constructor(
    key: string,
    parser: P = defaultParser as P,
    namespace = "snobase:",
  ) {
    this.key = key;
    this.parser = parser;
    this.namespace = namespace;
  }

  get namespacedKey() {
    return `${this.namespace}${this.key}`;
  }

  get() {
    if (typeof window === "undefined") return;
    const raw = window.sessionStorage.getItem(this.namespacedKey);
    if (raw === null) return null;
    return this.parser.parse(raw);
  }

  set(value: T) {
    if (typeof window === "undefined") return;
    const strVal = this.parser.stringify(value);
    return window.sessionStorage.setItem(this.namespacedKey, strVal);
  }

  remove() {
    if (typeof window === "undefined") return;
    return window.sessionStorage.removeItem(this.namespacedKey);
  }
}

export function createSessionStorageKeyJSON<T>(
  key: string,
  namespace?: string,
) {
  return new SessionStorageKey<T, typeof JSON>(key, JSON, namespace);
}
